import React, { Component } from 'react';
import { Button, Card, CardBody, CardHeader, Col, Container, Input, InputGroup, InputGroupAddon, InputGroupText, Row, NavLink } from 'reactstrap';

import CRNote from '../../Common/crNote'
import PageHead from '../../Common/pageHead'
import Menu from '../../Common/menu'

class Home extends Component {
  render() {
    	return (
      <div className="app align-items-center mcg">
        <span className="frontbk" style={{zIndex:"0"}} />

        <Container style={{zIndex:"1"}}>
          <PageHead/>
        </Container>

        <Container style={{zIndex:"2"}}>
          <Row className="justify-content-center">
            <Card className="mb-0">
            <Menu/>
              <CardHeader  className="titlehead">
                  <h1 className="mb-0 my-2">Who we are:</h1>
                  {/* <p className="text-center mb-0">Please fill out all fields then click Save Changes.</p>*/ }
                  <p className="text-left mb-0">
                  Ask My Phone combines the latest voice control technology and cloud computing to make the non-smart phones voice-controllable. Smartphones like iPhone can be controlled by voice.  But elderly prefers to use simple flip phones with big buttons and big fonts. The physical keypads and ease of use are the pros while limited computing power and lack of voice control are the cons of these phones.
                  </p>
                  <br />
                  <h1 className="mb-0 my-2">What we can do:</h1>
                  <p className="text-left mb-0">
                  With Ask My Phone, elderly can activate the SOS button on selected phones* with their voice. Once the SOS button is activated, the phone will send out SMS messages to 5 contacts and also dial out to 5 contacts in a round robin way until someone answers. For example, Bob is 75 years old and he lives alone. One night, he falls on the floor. His room is dark and he cannot reach his phone. Luckily, he has a smart speaker, for example, Amazon Echo installed and also he has Ask My Phone Skill enabled on Amazon Echo. So he said,”Alexa, Ask My Phone to send help”.  Ask My Phone service will then activate the SOS button of Bob’s flip phone. An emergency messages are sent to 5 friends/relatives and  his phone also dials out to these 5 friends/relatives. Once the call is picked up by someone, Bob’s flip phone will turn into a speaker phone mode and Bob can ask his friend to come over and help him out. To tackle the risk of phone failure, our system will also send out additional email and SMS to all contacts as a failsafe mechanism. 
                  </p>
                  <br />
                  <p className="text-left mb-0">
                  The elderly can contact individual friends with their voice. Through smart speakers, they can ask their phones to dial to their friends and then speak with their friends with speaker phone.
                  </p>
                  <br />
                  <h1 className="mb-0 my-2">What we cannot do:</h1>
                  <p className="text-left mb-0">
                  Although we tested our solution thoroughly, we still need your help in ensuring the whole system works. Currently, only Amazon Alexa, Google Home and selected phones* are supported in our solution. And please make sure all above components are powered up all the time.
                  </p>
                  <br />
                  <p className="text-left mb-0" style={{width:"100%"}}> * Selected phones now include VOCA V330 and V530</p>
              </CardHeader>
            </Card>
          </Row>
        </Container>

        <Container style={{zIndex:"2"}}>
          <CRNote/>
        </Container>
      </div>
    );
  }
}

export default Home;


// WEBPACK FOOTER //
// ./src/views/Pages/Home/Home.js